<div class="dialog-header">
    <h2 mat-dialog-title>Your session has expired.</h2>
    <mat-icon>drag_indicator</mat-icon>
</div>
<mat-dialog-content class="dialog-content">
    <p>
        Would you like to login again?
    </p>
    <!-- <iframe class="hidden-iframe" #hiddenIframe></iframe> -->
</mat-dialog-content>

<mat-dialog-actions align="end" >
    <button mat-button (click)='staySignedOut()'>Stay Signed Out</button>
    <button mat-flat-button color='primary' class='mat-stroked-button' (click)='login()'>Login</button>
</mat-dialog-actions>